import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ActivityFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const moduleOptions = [
    { value: '', label: 'All Modules' },
    { value: 'dashboard', label: 'Dashboard' },
    { value: 'inventory', label: 'Inventory' },
    { value: 'leads', label: 'Leads' },
    { value: 'tenants', label: 'Tenants' },
    { value: 'mandates', label: 'Mandates' },
    { value: 'settings', label: 'Settings' }
  ];

  const actionOptions = [
    { value: '', label: 'All Actions' },
    { value: 'create', label: 'Create' },
    { value: 'update', label: 'Update' },
    { value: 'delete', label: 'Delete' },
    { value: 'status_change', label: 'Status Change' },
    { value: 'assignment', label: 'Assignment' },
    { value: 'note_added', label: 'Note Added' },
    { value: 'bulk_action', label: 'Bulk Action' },
    { value: 'export', label: 'Export' },
    { value: 'import', label: 'Import' }
  ];

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Module Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Module
          </label>
          <Select
            value={filters?.module}
            onChange={(e) => onFilterChange('module', e?.target?.value)}
            options={moduleOptions}
          />
        </div>

        {/* Action Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Action
          </label>
          <Select
            value={filters?.action}
            onChange={(e) => onFilterChange('action', e?.target?.value)}
            options={actionOptions}
          />
        </div>

        {/* Start Date Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Start Date
          </label>
          <Input
            type="date"
            value={filters?.startDate}
            onChange={(e) => onFilterChange('startDate', e?.target?.value)}
          />
        </div>

        {/* End Date Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            End Date
          </label>
          <Input
            type="date"
            value={filters?.endDate}
            onChange={(e) => onFilterChange('endDate', e?.target?.value)}
          />
        </div>

        {/* Search Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search
          </label>
          <Input
            type="text"
            placeholder="Search description..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
          />
        </div>
      </div>
      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <div className="mt-4 flex justify-end">
          <Button onClick={onClearFilters} variant="outline" size="sm">
            <Icon name="X" className="w-4 h-4 mr-2" />
            Clear Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default ActivityFilters;